import Slider from "react-slick";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import BedIcon from "@mui/icons-material/Bed";
import BathtubIcon from "@mui/icons-material/Bathtub";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import TimeAgo from "../pages/webpage/components/timeAgo/TimeAgo";
import  "./PopularPropertiesCarousel.css"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bs-accent)",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        zIndex: 2,
        transition: "0.3s",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#d4a017")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "var(--bs-accent)")}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "var(--bs-accent)",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        zIndex: 2,
        transition: "0.3s",
      }}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.background = "#d4a017")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "var(--bs-accent)")}
    />
  );
}

const PopularPropertiesCarousel = ({ properties, navigate, openInquiryModal, logo }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  };

  return (
    <div className="container feature-section" style={{ maxWidth: "1250px", width: "100%" }}>
      <div className="col-lg-8">
        <h3 className="text-color">In-Demand Properties</h3>
      </div>

      <Slider {...settings} className="my-2">
        {properties.slice(0, 6).map((property, index) => (
          <div key={index} className="px-2">
            <div className="property-card">
              <div className="property-image-container position-relative">
                <div
                  className="property-image"
                  onClick={() => navigate(`/propertyDescription/${property._id}`)}
                >
                  <img
                    src={property.images[0] || "default-image.jpg"}
                    className="img-fluid"
                    alt="Property"
                  />
                </div>

                <div
                  className="popular-icon position-absolute"
                  style={{
                    top: "0px",
                    right: "0px",
                    borderRadius: "50%",
                    padding: "5px",
                  }}
                >
                  <img
                    src={logo}
                    alt="Popular"
                    style={{ width: "70px", height: "70px" }}
                  />
                </div>
              </div>

              <div className="property-details">
                <div className="d-flex justify-content-between my-2">
                  <h5 className="mb-0 homePage-title-heading">
                    {property.title || "Property"}
                  </h5>
                  <p className="property-price mb-0">
                    <CurrencyRupeeIcon fontSize="16" />
                    {property.price
                      ? `${property.price.toLocaleString("en-IN")}`
                      : "Price not available"}
                  </p>
                </div>

                <div className="d-flex justify-content-between my-2">
                  <p className="text-muted m-0">{property.city || "Unknown City"}</p>
                  <p className="text-muted m-0">
                    <TimeAgo createdAt={property.createdAt} />
                  </p>
                </div>

                <div className="dot-container mb-2 text-card-new mt-2">
                  <span className="d-flex align-items-center">
                    <BedIcon style={{ fontSize: 18, marginRight: 4 }} />
                    {property.numberOfBedrooms}
                  </span>
                  <div className="dot"></div>
                  <span className="d-flex align-items-center">
                    <BathtubIcon style={{ fontSize: 18, marginRight: 4 }} />
                    {property.numberOfBathrooms}
                  </span>
                  <div className="dot"></div>
                  <span className="d-flex align-items-center">
                    <SquareFootIcon style={{ fontSize: 18, marginRight: 4 }} />
                    {property.area} sq.ft
                  </span>
                </div>
              </div>

              {/* Buttons */}
              <div className="property-buttons">
                <button
                  className="btn"
                  onClick={() => navigate(`/propertyDescription/${property._id}`)}
                >
                  View Details
                </button>
                <button
                  className="btn"
                  onClick={() => openInquiryModal(property._id)}
                >
                  Get a Quote
                </button>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      <div className="d-flex justify-content-end">
        <button
          onClick={() => navigate(`/buyPage`)}
          className="btn-outline px-3 rounded-2 bg-transparent"
          style={{
            color: "var(--bs-accent)",
            border: "2px solid var(--bs-accent)",
          }}
        >
          See more
        </button>
      </div>
    </div>
  );
};

export default PopularPropertiesCarousel;
